export const NOTIFICATION_LIST_KEY = 'NOTIFICATION_LIST_KEY';
export const NOTIFICATION_USER_KEY = 'NOTIFICATION_USER_KEY';
export const NOTIFICATION_COUNT_KEY = 'NOTIFICATION_COUNT_KEY';
